import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GetCartItemsInterface } from '@app/feature/end-user/services/cart/GetCartItems.interface';
import { environment } from '@env/environment';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';

export interface IUpdateQty {
  id: number;
  order: 'DEC' | 'INC'
}

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.css']
})
export class CartItemComponent implements OnInit {
  @Input() item: GetCartItemsInterface;
  @Output() fn_UpdateQty = new EventEmitter<IUpdateQty>();
  @Output() fn_MoveToWishList = new EventEmitter<number>();
  @Output() fn_RemoveCartitem = new EventEmitter<number>();

  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;
  imgCustomBaseURLForWareHouseproduct =  environment.warehouseProductCustomImageFolder;
  userRole: string;
  sampleOrderForStoreAdmin: string;
  productImage: string;
  constructor(private designHuddleImageService: DesignHuddleImageService) {
  }

  ngOnInit() {
    this.sampleOrderForStoreAdmin = localStorage.getItem('sampleOrder')
    this.userRole = localStorage.getItem('role');
    if (this.userRole == undefined)
      this.userRole = 'GuestUser';

    this.productImage = this.getCartItemImage(this.item);
  }

  getCartItemImage(item: any): string {
    return this.designHuddleImageService.getCartItemImage(item);
  }

}
